// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// ✅ Your Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyByyIb5lycLZznmHm3FVIy8IYInUzo30AY",
  authDomain: "we-study-43745.firebaseapp.com",
  databaseURL: "https://we-study-43745-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "we-study-43745",
  storageBucket: "we-study-43745.appspot.com",
  messagingSenderId: "824953922910",
  appId: "1:824953922910:web:41a495ddfa400b505adbcf",
  measurementId: "G-7XWMY7K6T8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
